import React from "react";
import { Typography, Button } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import video0hub from "../../assets/Video-hub.jpg";
import video1 from "../../assets/home/h2.png";
import video2 from "../../assets/home/h3.png";
import video3 from "../../assets/home/v2.png";
import video4 from "../../assets/Vh1.jpg";

const { Title, Text, Paragraph } = Typography;

const VideoHub = () => {
  const latestVideos = [
    { id: 1, image: video1, title: "Heroes Cup: tournament dedicated to honoring laborers", description: "This initiative celebrates the strength, teamwork and spirit of the people who build our communities." },
    { id: 2, image: video2, title: "Bloom Day: Yalla Nellab Announces a New Initiative for Special Children", description: "Supported by volunteers and local partners, Bloom Day reflects Yalla Nellab’s ongoing commitment to making sports accessible to everyone." },
    { id: 3, image: video3, title: "Open Events :community games for everyone to join and play.", description: "Experience the joy of sports, make new connections and be part of a growing community that plays for passion, not competition." },
    { id: 4, image: video4, title: "Jiu-Jitsu Gaining Popularity", description: "Prompted by the vision and support of the UAE Royal Family, Jiu-Jitsu is rapidly gaining popularity across our community." },
  ];

  // Duplicate videos to show two rows
  const allVideos = [...latestVideos, ...latestVideos];

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f9f9f9" }}>
      {/* Header */}
      <div
        style={{
          width: "100%",
          height: "100px",
          display: "flex",
          alignItems: "center",
          padding: "0 5%",
          boxSizing: "border-box",
        }}
      >
        <Title level={2} style={{ fontWeight: 700, color: "#000", margin: 0 }}>
          Video Hub
        </Title>
      </div>

      {/* Hero Image with overlay */}
      <div style={{ margin: "0 5%", position: "relative" }}>
        <img
          src={video0hub}
          alt="Video Hub"
          style={{ width: "100%", height: "auto", display: "block" }}
        />

        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "5%",
            color: "#fff",
            maxWidth: "90%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
            <div
              style={{
                width: 4,
                height: 24,
                backgroundColor: "#ED1C24",
                marginRight: 8,
              }}
            ></div>
            <Text style={{ fontWeight: 600, fontSize: "14px", color: "#fff", letterSpacing: 1 }}>
              COMMUNITY &nbsp; FRI 6 JUNE 2025
            </Text>
          </div>

          <Title
            level={2}
            style={{
              fontWeight: 800,
              color: "#fff",
              fontSize: "clamp(24px, 4vw, 38px)",
              marginBottom: 40,
              whiteSpace: "nowrap",
            }}
          >
            Celebrating World Ocean Day
          </Title>

          <Button
            type="primary"
            style={{
              backgroundColor: "#ED1C24",
              borderColor: "#ED1C24",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              padding: "18px 36px",
              display: "flex",
              alignItems: "center",
              borderRadius: 0,
            }}
            icon={<CaretRightOutlined style={{ fontSize: "22px", marginRight: 10 }} />}
          >
            Watch Now
          </Button>
        </div>
      </div>

      {/* Latest Videos Section */}
      <div style={{ padding: "60px 5%" }}>
        <Title level={3} style={{ fontWeight: 700, marginBottom: 40 }}>
          Latest Videos
        </Title>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
          }}
        >
          {allVideos.map((video, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: 4,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {/* Image Container */}
              <div style={{ width: "100%", height: "220px", overflow: "hidden", borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                <img
                  src={video.image}
                  alt={`Video ${video.id}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }} // uniform size for all
                />
              </div>

              <div style={{ padding: "16px", flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                  <Text
                    style={{ fontWeight: 700, fontSize: "16px", color: "#000", display: "block", marginBottom: 8 }}
                  >
                    {video.title}
                  </Text>
                  <Paragraph style={{ fontSize: "14px", color: "#545454", marginBottom: 12 }}>
                    {video.description}
                  </Paragraph>
                </div>
                <Button type="link" style={{ padding: 0, fontWeight: 600, color: "#000", alignSelf: "flex-start" }}>
                  Read More-
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* LOAD MORE Button */}
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Button
            type="primary"
            style={{
              backgroundColor: "#ED1C24",
              borderColor: "#ED1C24",
              color: "#fff",
              fontWeight: 700,
              fontSize: "16px",
              padding: "22px 40px",
              borderRadius: 0,
            }}
          >
            LOAD MORE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VideoHub;
